import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

interface Params {
  clientId: string;
  accountId: string;
}

const rejectReview = ({ clientId, accountId }: Params) =>
  authFetch('/Adviser/ManagedAccountInvestigation/Reject', {
    method: 'POST',
    ...httpBodyOptions(
      {
        clientId,
        managedAccountId: accountId,
      },
      true,
    ),
  });

export const useRejectReviewMutation = () => {
  return useMutation(rejectReview);
};
